import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { SharedService } from '../../../services/shared/shared.service';

@Component({
  selector: 'app-how-work',
  imports: [CommonModule,HeroComponent],
  templateUrl: './how-work.component.html',
  styleUrl: './how-work.component.css'
})
export class HowWorkComponent {
  constructor(public sharedService: SharedService) { }

  @Input() showHero:boolean = true;
}
